import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const API = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' }
});

export const UPLOADS_URL = `${API_URL}/uploads`;

export default API;
